/* src/app/self-enrollment/email-verification/email-verification.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
/*# sourceMappingURL=email-verification.component.css.map */
